import { Component, ViewChild, ElementRef, AfterViewInit, OnInit } from '@angular/core';
/*import { LlScrollpaneService } from '../ll-scrollpane.service';*/
import { LlPermissionsService } from '../ll-permissions.service';
import { LlRolesService } from '../ll-roles.service';
import { LlModelsService } from '../ll-models.service';

@Component({
  selector: 'll-loanmgmt-bbc-switch',
  templateUrl: './ll-loanmgmt-bbc-switch.component.html',
  styleUrls: ['../cssMain.css']
})
export class LlLoanmgmtBBCSwitchComponent {

  @ViewChild('mainDiv_ll_loanmgmt_bbc_switch') mainDiv: ElementRef;
  /*@ViewChild('horzTabs_ll_loanmgmt_bbc_switch') public horzTabs: ElementRef;*/

  constructor(
    private LlRolesService: LlRolesService,
    private LlPermissionsService: LlPermissionsService,
    private LlModelsService: LlModelsService,
  ) { }

  bundle = {
    showHorzTabs: false,
    showRemaining: false,
    function: '',
    parentW: 0,
    parentH: 0,
    remainingX: 0,
    remainingY: 40,
    remainingW: 0,
    remainingH: 0,
    showTab: true,
    hTabIndx: 0,
    horzTabs: [],
    collateral: [],
    activeHorzTab: '',
    LOANMODELBBCRECORDID: 0,
  }

  ngOnInit() { }

  ngOnDestroy() { }

  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {
    this.bundle.showHorzTabs = false;
    this.bundle.showRemaining = false;

    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;

    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.remainingW = this.bundle.parentW;;
      this.bundle.remainingH = this.bundle.parentH - this.bundle.remainingY;

      this.getData()
    });
  }

  getData() {

    let SYSTEMROLEID = this.LlRolesService.getActiveContactRoleId();

    this.bundle.LOANMODELBBCRECORDID = this.LlModelsService.getActiveLOANMODELBBCRECORDID()

    this.bundle.horzTabs.splice(0);

    this.bundle.horzTabs.push({ lbl: "Enter BBC Data" });
    this.bundle.horzTabs.push({ lbl: "View-Print BBC PDF" });    

    this.bundle.activeHorzTab = this.bundle.horzTabs[0].lbl;

    this.bundle.collateral.splice(0);
    this.bundle.collateral.push({ lbl: "Locations" });
    this.bundle.collateral.push({ lbl: "Classes" });
    this.bundle.collateral.push({ lbl: "Payers" });
    this.bundle.collateral.push({ lbl: "Unposted" });
    this.bundle.collateral.push({ lbl: "Location-Payers" });


    this.bundle.showHorzTabs = true;
    this.bundle.showRemaining = true;

  }

  selectTab(label) {
    this.bundle.activeHorzTab = label;

    if (label === 'Locations') {
      this.LlModelsService.setActiveSYSTEMOPERATIONREPORTSID(78);
    } else if (label === 'Classes') {
      this.LlModelsService.setActiveSYSTEMOPERATIONREPORTSID(79);
    } else if (label === 'Payers') {
      this.LlModelsService.setActiveSYSTEMOPERATIONREPORTSID(80);
    } else if (label === 'Unposted') {
      this.LlModelsService.setActiveSYSTEMOPERATIONREPORTSID(77);
    } else if (label === 'Location-Payers') {
      this.LlModelsService.setActiveSYSTEMOPERATIONREPORTSID(81);
    }

  }
}
